import "./styles.scss";

import { useSelector } from "react-redux";
import { IoIosClose } from "react-icons/io";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, Fragment } from "react";

function ModalGenerateExercisesWithAI({ showModal, setShowModal }) {
  const iframeRef = useRef(null);
  const { t } = useTranslation();
  const { contentFilesExercisesSelected } = useSelector((state) => state.contentExercisesReducer);

  const [frameLoaded, setFrameLoaded] = useState(false);

  const exerciseHtml = contentFilesExercisesSelected?.exerciseHtml || "";

  const closeModal = () => setShowModal(false);

  useEffect(() => {
    setFrameLoaded(false);
  }, [exerciseHtml]);

  return (
    <Dialog open={showModal} onClose={closeModal} className="modalGenerateExercisesWithAI">
      <button onClick={closeModal} className="buttonClose" aria-label="Fechar modal">
        <IoIosClose color={"#fff"} size={24} />
      </button>

      <div className="containerGenerateExercisesWithAI">
        <div className="exerciseHtmlContent">
          {!exerciseHtml ? (
            <div className="exerciseHtmlEmpty">
              <p>No exercises available for viewing.</p>
            </div>
          ) : (
            <Fragment>
              {!frameLoaded && (
                <div className="exerciseHtmlLoading" style={{ display: "none" }}>
                  {t("LOADING")}
                </div>
              )}

              <iframe
                ref={iframeRef}
                title="AI Exercise"
                srcDoc={exerciseHtml}
                className="exerciseHtmlFrame"
                onLoad={() => setFrameLoaded(true)}
                sandbox="allow-scripts allow-forms"
              />
            </Fragment>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default ModalGenerateExercisesWithAI;
